import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../shared/services/auth.service';
import { ApiService } from '../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatosDenuncia } from 'src/app/shared/models/datosDenuncia';
import { Usuarios } from '../dashboard/models/usuarios';
import { PlazosDenuncia } from '../model/plazosDenuncia';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'app-asignar-decisor',
  templateUrl: './asignar-decisor.component.html',
  styleUrls: ['./asignar-decisor.component.css']
})
export class AsignarDecisorComponent implements OnInit {
  assetsUrl: string = environment.baseAssetsUrl;
  validatingForm: FormGroup;
  @Input() denuncia: DatosDenuncia;

  /** Available decisors (filtered). */
  decisores: Usuarios[];
  /** Decisors already assigned to the complaint. */
  decisoresSelected: Usuarios[];
  /** Deadlines data for the complaint. */
  plazos: PlazosDenuncia[];

  constructor(private apiService: ApiService, private auth: AuthService, private router: Router, private toastr: ToastrService, private translate: TranslateService) { }

  ngOnInit(): void {
    const language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);

    this.validatingForm = new FormGroup({
      selectDecisor: new FormControl('', [Validators.required])
    });

    this.getDecisorsAssigned();

  }

  checkDecisorsAvailability() {
    if (this.decisores == null || this.decisores.length == 0) {
      this.toastr.error(this.translate.instant('texto_929'));
    }
  }

  /**
   * Load currently assigned decisors for the complaint.
   */
  getDecisorsAssigned(): void {
    this.apiService
      .searchInvesSelect(this.auth.getSociedad(), this.denuncia[0].id_denuncia, '3')
      .pipe(
        finalize(() => {
          this.getAvailableDecisors();
        })
      )
      .subscribe({
        next: (response: any) => {
          this.decisoresSelected = response?.data || [];
        },
        error: () => {
          this.decisoresSelected = [];
        }
      });
  }

  /**
   * Load available decisors, excluding those with conflicts of interest.
   */
  getAvailableDecisors() {
    this.apiService.searchUserByIdSocietyRole(this.auth.getSociedad(), "3", false, "nulo").subscribe({
      next: (response: any) => {
        const list = response || [];
        const rejectReceptor = this.denuncia?.[0]?.id_receptor_rechazado || null;
        const selectedIds = this.decisoresSelected?.map((u: any) => String(u.id_user ?? "")) || [];

        this.apiService.searchUserComplianceByIdSocietyRole(this.auth.getSociedad(), this.denuncia[0].id_denuncia).subscribe({
          next: (compResp: any) => {
            const rawCompReject = compResp?.[0]?.id_usuario_comp_rechazado || null;
            const compRejectIds = rawCompReject ? rawCompReject.split(",").map((s: any) => s.trim()).filter((s: any) => s) : [];

            this.decisores = list.filter((d: any) => {
              const uid = String(d.id_user ?? "");
              return uid !== String(rejectReceptor) && !compRejectIds.includes(uid) && !selectedIds.includes(uid);
            });
          },

          error: () => {
            this.decisores = list.filter((d: any) => {
              const uid = String(d.id_user ?? "");
              return uid !== String(rejectReceptor) && !selectedIds.includes(uid);
            });
          }
        });
      },

      error: () => {
        this.decisores = [];
        this.toastr.error(this.translate.instant('texto_890'));
      }
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
  }

  get selectDecisor() {
    return this.validatingForm.get('selectDecisor');
  }

  /**
   * Add decision maker to complaint
   */
  asignarDecisor() {
    if (this.selectDecisor.valid) {
      this.apiService.addDecisor(this.auth.getSociedad(), this.selectDecisor.value, this.denuncia[0].id_denuncia, this.auth.getIdUser()).subscribe({
        next: (res) => {
          if (res.code === 200 && res.data) {
            this.toastr.success(
              this.translate.instant('texto_296'),
              this.translate.instant('texto_297')
            );
            this.router
              .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
              .then(() => {
                this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
              });
          }
        },
        error: (err) => {
          this.toastr.error(
            this.translate.instant('texto_298'),
            this.translate.instant('texto_297')
          );
        },
      });
    }
  }

  /**
   * Remove the decisor assignment from the complaint.
   */
  deleteDecisor(id_user: string) {
    this.apiService.countInvesSelect(this.auth.getSociedad(), this.denuncia[0].id_denuncia, id_user, "3").subscribe(
      res => {
        if (res == 200) {
          this.apiService.deleteInvesSelect(id_user, this.auth.getSociedad(), this.denuncia[0].id_denuncia, "3").subscribe(
            res => {
              if (res == 200) {
                this.toastr.success(this.translate.instant('texto_462'), this.translate.instant('texto_463'));
              } else {
                this.toastr.error(this.translate.instant('texto_464'), this.translate.instant('texto_463'));
              }
            });
        } else {
          this.toastr.error(this.translate.instant('texto_464'), this.translate.instant('texto_463'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
        });
      });
  }
}
